export enum Empty {
  VALUE = 'blank',
}
export const isBlank = (key: string) => key === Empty.VALUE;
